import { Currency } from '../types/invoice';

export const CurrencySymbols: Record<Currency, string> = {
  [Currency.USD]: '$',
  [Currency.EUR]: '€',
  [Currency.CNY]: '¥',
  [Currency.GBP]: '£',
  [Currency.CAD]: 'C$',
  [Currency.PLN]: 'zł'
};

export const formatCurrency = (amount: number, currency: string): string => {
  const symbol = CurrencySymbols[currency as Currency] || currency;
  return `${amount.toLocaleString('ru-RU', { minimumFractionDigits: 2 })} ${symbol}`;
};
